<template>
    <div class="order-list fadeIn" @scroll="scrollEvent" id="order"
         :class="{ 'openBox': isActive, 'openBox no-pic': posFoodImage==='' }">
        <div class="topNav">
            <navigation-bar Close/>
        </div>
        <div class="top-banner" id="top-banner">
            <el-image :src="posFoodImage" fit="cover" v-if="posFoodImage!==''">
                <div slot="error" class="image-slot"/>
            </el-image>
        </div>
        <div class="container-fluid">
            <!--todo 單點＋套餐名稱用-->
            <div class="order-detail">
                <h4>
                    <b>{{dataObject.couponTypeId === 1 || dataObject.couponTypeId === 3 ? `[${dataObject.couponTypeName.slice(0, 2)}] ` : ""}}{{posFoodName}}</b>
                    <template v-if="isTableOrderAddItemUse">
                        <span v-if="dataObject.couponTypeId === 3" class="red">NT${{addPrice}}</span>
                    </template>
                    <span v-else class="red">NT${{price}} <span class="small" v-if="increasAble">起</span></span>
                </h4>
                <div class="detail" v-html="description"></div>
            </div>

            <!--todo 以下為套餐使用區塊-->
            <template v-if="orderType===2">
                <!--todo 套餐的第二層樣式+註記-->
                <div v-for="(item,index) in mealCombination" :key="index" class="order-detail" :combinationElementId="item.id">
                    <h4>
                        {{item.name}}
                        <span class="small">選擇 <b class="red">1</b></span>
                    </h4>
                    <el-radio-group v-model="tempChoiceList[0][index]" class="radio-tick-shadow">

                        <el-radio v-for="(item2,index2) in item.posFoodSubmealList" :key="index2" @change="$forceUpdate()" :label="index2">
                            <span class="title">{{item2.posFoodName}}</span>
                            <span class="fee red" v-text="item2.increasePrice>0?'+$'+Math.abs(item2.increasePrice):''+item2.increasePrice<0?'-$'+Math.abs(item2.increasePrice):''"></span>
                            <!--todo 套餐的註記-->
                            <template v-if="tempChoiceList[0][index]===index2">
                                <el-checkbox-group v-for="(item3,index3) in item2.posFoodGoodsNoteList" :key="index3" v-model="tempChoiceList[1][index][index2][index3]" :noteId="item3.posGoodsNoteId+''+index" class="type-circle">
                                    <div class="small ps">{{item3.posGoodNoteName}}
                                        <template v-if="item3.minChoice>0&&item3.maxChoice>0&&item3.minChoice===item3.maxChoice">
                                            必選 <b class="red">{{item3.maxChoice}}</b>
                                        </template>
                                        <template v-else>
                                            <template v-if="item3.minChoice>0&&item3.noteSwitch">
                                                最少選擇 <b class="red">{{item3.minChoice}}</b>
                                            </template>
                                            <template v-if="item3.maxChoice&&item3.noteSwitch>0">
                                                最多選擇 <b class="red">{{item3.maxChoice}}</b>
                                            </template>
                                        </template>
                                    </div>
                                    <el-checkbox v-for="(item4,index4) in item3.posGoodsNoteDetailList" :key="index4" @change="$forceUpdate()" :label="index4" :disabled="item3.noteSwitch && item3.maxChoice > 0 && tempChoiceList[1][index][index2][index3].length >= item3.maxChoice && tempChoiceList[1][index][index2][index3].indexOf(index4) === -1">
                                        <span class="title">{{item4.name}}</span>
                                        <span class="fee red" v-text="item4.increasePrice>0?'+$'+Math.abs(item4.increasePrice):''+item4.increasePrice<0?'-$'+Math.abs(item4.increasePrice):''"></span>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </template>
                        </el-radio>

                    </el-radio-group>
                </div>
            </template>
            <!--todo 以上為套餐使用區塊-->

            <!--todo 以下為單點使用區塊-->
            <template v-if="orderType===1">
                <!--todo 單點的註記-->
                <div v-for="(item,index) in mealCombination" :noteId="item.posGoodsNoteId" :key="index" class="order-detail">
                    <h4>
                        {{item.posGoodsNoteName}}
                        <span class="small" v-if="item.noteSwitch">
                            <template v-if="item.minChoice>0&&item.maxChoice>0&&item.minChoice===item.maxChoice">
                                選擇 <b class="red">{{item.maxChoice}}</b>
                            </template>
                            <template v-else>
                                {{item.minChoice>0?'最少選擇 ':''}} <b class="red">{{item.minChoice>0?item.minChoice:''}}</b>
                                {{item.maxChoice>0?'最多選擇 ':''}} <b class="red">{{item.maxChoice}}</b>
                            </template>
                        </span>
                    </h4>
                    <el-checkbox-group v-model="tempChoiceList[index]" class="type-check">
                        <!--todo 有預設選取的樣式-->
                        <el-checkbox v-for="(item2,index2) in item.posGoodsNoteDetailList" :key="index2" :label="index2" :disabled="item.noteSwitch && item.maxChoice > 0 && tempChoiceList[index].length >= item.maxChoice && tempChoiceList[index].indexOf(index2) === -1">
                            <span class="title">{{item2.name}}</span>
                            <span class="fee red" v-text="item2.increasePrice>0?'+$'+Math.abs(item2.increasePrice):''+item2.increasePrice<0?'-$'+Math.abs(item2.increasePrice):''"></span>
                        </el-checkbox>
                    </el-checkbox-group>

                </div>
                <!--todo 單點才有餐點指示-->
                <div class="order-detail">
                    <h4>
                        餐點指示
                    </h4>
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        v-model="textNote"
                        :placeholder="remarkPrompt === '' ? '請輸入餐點指示' : remarkPrompt">
                    </el-input>
                </div>
            </template>
            <!--todo 以上為單點使用區塊-->

            <div class="text-center">
                <number-controller v-if="!isTableOrderAddItemUse" :params="numberControllerParams" @triggerEvent="numberControllerEvent"/>
            </div>


            <!--todo 刪除此餐點彈框-->
            <el-dialog
                :visible.sync="showModel"
                top="20%"
                width="80%"
                custom-class="commDialog">
                <div class="container">
                    <img src="../../assets/images/dialog-order.svg" class="icon">
                    <h4 class="text-center">確定要刪除此餐點？</h4>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="info">確定刪除</el-button>
                    </div>
                </div>
            </el-dialog>

        </div>

        <div @click="addCart(submitBtnStatus)" class="CartButton">
            <div :class="{'disabled':submitBtnStatus.disabled}" class="button">
                <!--todo 加入購物車後再進入改成更新購物車-->
                <div class="text">
                    {{isTableOrderAddItemUse ? "確定" : `新增${tempChoiceAmount}份至購物車`}}
                    <!--更新購物車-->
                </div>
                <div class="fee" v-if="(isTableOrderAddItemUse && (choicePrice + addPrice) > 0) || !isTableOrderAddItemUse">
                    ${{isTableOrderAddItemUse ? choicePrice + addPrice : choicePrice}}
                </div>
            </div>
        </div>
        <el-dialog
                class="dialog"
                :visible.sync="isShowDialog"
                :show-close="false"
                top="40%"
                width="80%"
                custom-class="commDialog">
            <div class="container" id="commDialogContainer">
                <img src="../../assets/images/dialog_cart.svg" class="icon">
                <span class="main-content mt-0">你已選擇了不同品牌，如要繼續<br>您的購物車將被清空</span>
                <div class="dialog-footer">
                    <el-button round type="primary" @click="isShowDialog = false">關閉</el-button>
                    <el-button round type="info" @click="clearCart">是</el-button>
                </div>
            </div>
        </el-dialog>

        <comm-dialog :value="isShowMsgDialog"
                     :outerContent="dialogMsg"
                     :isCancel="false"
                     :icon="icons"
                     positiveLabel="關閉"
                     @result="onDialogResult">
        </comm-dialog>

        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
    </div>


</template>

<script>
    //import NavigationBar from '@/components/NavigationBar.vue';
    import {notNull} from '@/util/common';
    import * as mutationTypes from '@/store/mutationTypes';
    import NumberController from "@/components/NumberController";
    import * as constDefine from "@/store/constDefine";
    import CommDialog from "@/components/CommDialog";
    import Analytics from '@/util/analytics';

    export default {
        name: "OrderDetail",
        components: {
          //NavigationBar,
          NumberController,
          CommDialog,
        },
        data() {
            return {
                isActive: false,
                showModel: false,

                isCached: false,        //sqlite是否已暫存
                storeId: this.$route.params.storeId?this.$route.params.storeId:0,
                posFoodId: Number(this.$route.query.id),
                posFoodName: '',
                posFoodImage: '',
                price: 0,
                increasAble: false,
                description: '',
                remarkPrompt: '',
                isLimit: false,
                limitAmount: 0,
                orderType: 0,           //1為單點，2為套餐
                mealCombination: [],    //選項組合
                tempChoiceList: [],     //選項選擇狀態
                backTempChoiceList: [], //選擇狀態備份
                tempChoiceAmount: 1,    //選擇數量
                textNote: '',
                isShowDialog: false,    //清空購物車彈框
                cartStoreId: this.$store.state.cartStoreId, //當前購物車StoreId
                takeoutId: this.$route.params.takeoutId,
                mealChoiceListTable: Number(this.$route.params.takeoutId) > 0 ? 'order_record_meal_choiceList' : 'shopping_cart_meal_choiceList',     //餐點選項資料表（sqlite）
                mealDataTable: Number(this.$route.params.takeoutId) > 0 ? 'order_record_meal_data' : 'shopping_cart_meal_data',                       //餐點資料資料表（sqlite）
                numberControllerParams: {
                  default: 1,
                  min: 1,
                },
                mealCount: 0,
                isCordova: this.$public.isCordova(),
                isOnlineOrder: Boolean(sessionStorage.getItem("isOnlineOrder")),
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",
                dataObject: {},
                isTableOrderAddItem: false,
                isTableOrderAddItemUse: false,
                orderId: 0,
                isLoading: false,
                isShowMsgDialog: false,
                dialogMsg: "",
                icons: require('@/assets/images/dialog_question.svg'),
                msgDialogStatus: false,
                addPrice: 0,
                //掃碼兌換成功秀資訊
                exchange:{
                    time: '',   //兌換的時間
                },

                analytics: null,
            }
        },
        created() {
            this.$store.watch((state, getter) => {
                return state.cartStoreId;
            }, (newVal) => {
                this.cartStoreId = newVal;
            });

            if(!this.isCordova) {
              try {
                this.dataObject = this.$crypto.uriComponentToObject(sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken));
                if(this.dataObject.isChecked) {
                  if(typeof this.dataObject.posFoodId !== "undefined") {
                    this.posFoodId = this.dataObject.posFoodId;
                    this.storeId = this.dataObject.storeId;
                    this.cartStoreId = this.dataObject.storeId;
                    this.takeoutId = this.dataObject.takeoutId;

                    if (this.dataObject.usedType === constDefine.QRCodeUsedType.TableOrderAddItem) {
                      this.isTableOrderAddItem = true
                      this.orderId = Number(this.dataObject.orderId);
                      this.analytics = Analytics.getInstance(this.$route, "QRCodeOrder");
                    } else if (this.dataObject.usedType === constDefine.QRCodeUsedType.TableOrder) {
                      this.analytics = Analytics.getInstance(this.$route, "TableOrder");
                    }
                  }
                } else {
                  if(this.dataObject.routePath) {
                    this.$router.push({path: this.dataObject.routePath})
                  } else {
                    this.$router.push({name:'Error'});
                  }
                  return false;
                }

                if(this.storeId === 0) {
                  this.$router.push({name:'Error'});
                  return false;
                }
              } catch (e) {
                if(!this.isOnlineOrder) {
                  this.$router.push({name:'Error'});
                  return false;
                } else {
                  this.analytics = Analytics.getInstance(this.$route, "OnlineOrder");
                }
              }
            } else {
                if(this.dataToken !== "") {
                    try {
                        this.dataObject = this.$crypto.uriComponentToObject(this.dataToken);
                        if (this.dataObject.usedType === "tableOrderAddItemUse") {
                            this.posFoodId = this.dataObject.posFoodId;
                            this.storeId = this.dataObject.storeId;
                            this.cartStoreId = 0;
                            this.takeoutId = 0;
                            this.isTableOrderAddItem = true
                            this.isTableOrderAddItemUse = true
                            this.orderId = Number(this.dataObject.orderId);
                            this.analytics = Analytics.getInstance(this.$route, "QRCodeOrder");
                        } else {
                            this.$router.go(-1)
                        }
                    } catch (e) {
                        this.$router.go(-1)
                    }
                } else if (this.isOnlineOrder) {
                    this.analytics = Analytics.getInstance(this.$route, "OnlineOrder");
                } else {
                    this.analytics = Analytics.getInstance(this.$route, "TableOrder");
                }
            }

            this.setupData();
        },
        mounted() {
            let self = this;
            let callback = (resultSet) => {
                self.mealCount = self.isCordova ? resultSet.rows.length : resultSet.length;

                if (self.mealCount === 0 && self.cartStoreId > 0) {
                    self.$store.commit('setCartStoreId', 0);
                }
            }

            if (self.isCordova) {
                self.$sqlite.query('select * from ' + self.mealChoiceListTable, [], callback)
            } else {
                self.$sqlite.queryDB(self.mealChoiceListTable, "", "", callback)
            }
        },
        methods: {
            scrollEvent(){
                //偵測區塊捲動的高度
                let scroll=document.getElementById("order").scrollTop
                //偵測banner的高度
                let HH=document.getElementById("top-banner").offsetHeight- 60
                if(scroll>HH){
                    this.isActive=true
                }
                if(scroll<=HH){
                    this.isActive=false
                }
            },
            setupData(){
                this.GetPosFoodDetail();
            },
            GetPosFoodDetail() {
                let self = this;
                let callback = function (resultSet) {

                    let length = self.isCordova ? resultSet.rows.length : resultSet.length;

                    //使用優惠券開啟的，無視快取
                    if (self.isTableOrderAddItemUse) {
                        length = 0
                    }

                    if (length > 0) {
                        let dataJson = self.isCordova ? resultSet.rows.item(0).data_json : resultSet[0].data_json;

                        self.isCached = true;
                        setData(JSON.parse(dataJson));
                    } else {
                        self.isLoading = true;
                        self.$http.fetch`GetPosFoodDetail${{
                            'posFoodId': self.posFoodId,
                            'isTableOrderAddItem': self.isTableOrderAddItem,
                            'orderId': self.orderId,
                        }}
                        ${json => {
                            self.isLoading = false;
                            if (notNull(json.data)) {
                                setData(json.data);
                            }
                        }}`;
                    }
                }

                if (self.isCordova) {
                    this.$sqlite.query("select * from " + this.mealDataTable + " where meal_id = ?", [self.posFoodId], callback);
                } else {
                    this.$sqlite.queryDB(this.mealDataTable, "meal_id", self.posFoodId, callback);
                }

                let setData = function (data) {
                    self.posFood = data;
                    self.posFoodName = data.posFoodInfo.onlineOrderName;
                    self.posFoodImage = data.posFoodInfo.onlineOrderFoodImage;
                    self.price = data.posFoodInfo.onlineOrderPrice;
                    self.description = data.posFoodInfo.onlineOrderDescription;
                    self.remarkPrompt = data.posFoodInfo.onlineOrderRemarkPrompt;
                    self.orderType = data.posFoodInfo.orderType;
                    self.isLimit = data.posFoodInfo.isLimit;
                    self.limitAmount = data.posFoodInfo.limitAmount;
                    self.mealCombination = data.dataList;

                    if (self.isTableOrderAddItemUse) {
                        self.price = 0;
                        self.addPrice = self.dataObject.amount;
                    }

                    // 單點帶入選項組合
                    if (self.orderType === 1) {
                        // 移除餐點註記
                        self.mealCombination = self.mealCombination.filter(function (item) {
                            return item.noteType !== 1 && item.posGoodsNoteDetailList.length > 0;
                        });
                        self.tempChoiceList = self.mealCombination.map((combination, combinationIndex) => {
                            let preOption = [];

                            combination.posGoodsNoteDetailList.forEach((noteDetail, noteDetailIndex) => {
                                // 預設選項
                                if (noteDetail.preset) {
                                    preOption.push(noteDetailIndex);
                                }
                                // 如果有加價購，價格顯示加  （起）
                                if (!self.increasAble && noteDetail.increasePrice > 0) {
                                    self.increasAble = true;
                                }
                            });
                            return preOption;
                        });
                    } else if (self.orderType === 2) {

                        // 移除餐點註記
                        self.mealCombination = self.mealCombination.map(function (combination) {
                            combination.posFoodSubmealList.map(function (submeal) {
                                submeal.posFoodGoodsNoteList = submeal.posFoodGoodsNoteList.filter(function (note) {
                                    return note.noteType !== 1 && note.posGoodsNoteDetailList.length > 0;
                                });
                                return submeal;
                            });
                            return combination;
                        });


                        // self.tempChoiceList = [];


                        self.$set(self.tempChoiceList, 0, []);        //紀錄餐點
                        self.$set(self.tempChoiceList, 1, []);        //紀錄選項
                        self.$set(self.tempChoiceList, 0, self.mealCombination.map((combination, combinationIndex) => {
                            let mainOption = '';
                            self.$set(self.tempChoiceList[1], combinationIndex, []);
                            combination.posFoodSubmealList.forEach((submeal, submealIndex) => {
                                // 預設選項
                                if (submeal.preset) {
                                    mainOption = submealIndex;
                                }
                                // 如果有加價購，價格顯示加  （起）
                                if (!self.increasAble && submeal.increasePrice > 0) {
                                    self.increasAble = true;
                                }
                                self.$set(self.tempChoiceList[1][combinationIndex], submealIndex, []);
                                submeal.posFoodGoodsNoteList.forEach((note, noteIndex) => {
                                    self.tempChoiceList[1][combinationIndex][submealIndex][noteIndex] = [];
                                    note.posGoodsNoteDetailList.forEach((noteDetail, noteDetailIndex) => {
                                        // 預設選項
                                        if (noteDetail.preset) {
                                            self.tempChoiceList[1][combinationIndex][submealIndex][noteIndex].push(noteDetailIndex);
                                        }
                                        // 如果有加價購，價格顯示加  （起）
                                        if (!self.increasAble && noteDetail.increasePrice > 0) {
                                            self.increasAble = true;
                                        }
                                    });
                                });
                            });
                            return mainOption;
                        }));
                        self.backTempChoiceList = JSON.parse(JSON.stringify(self.tempChoiceList));
                    }
                    // 把要存進去的資料也濾掉註記跟沒有選項的
                    self.posFood.dataList = self.mealCombination;
                    // 從購物車回來，帶入選項
                    if (self.$route.params.choiceList !== undefined) {
                        self.tempChoiceList = self.$route.params.choiceList;
                    }
                    // 從購物車回來，帶入數量
                    if (self.$route.params.choiceAmount !== undefined) {
                        self.tempChoiceAmount = self.$route.params.choiceAmount;
                        self.numberControllerParams.default = Number(self.tempChoiceAmount);
                    }
                    // 從購物車回來，帶入餐點指示
                    if (self.$route.params.textNote !== undefined) {
                        self.textNote = self.$route.params.textNote;
                    }
                }

            },
            addCart(submitBtnStatus) {
                let self = this;
                if (self.isTableOrderAddItemUse) {
                    self.cartStoreId = 0
                    self.mealCount = 0
                }

                //如果當前購物車的StoreId與正在加入的商品的StoreId不同 則跳確認清空購物車彈框
                if ((this.cartStoreId !== 0 && this.cartStoreId !== this.storeId && this.storeId !== 0 && this.takeoutId === 0) || (this.mealCount > 0 && this.cartStoreId === 0)) {
                    this.isShowDialog = true;
                } else if (submitBtnStatus.disabledDo.length > 0 && submitBtnStatus.disabled) {
                    submitBtnStatus.disabledDo.forEach(function (item) {
                        item();
                    });
                } else {
                    if (self.isTableOrderAddItemUse) {
                        self.$store.commit(mutationTypes.setPublicCommDialogData, {
                            isShowDialog: true,
                            outerContent: `確定使用本券<div class="text-left small mt-2"><i class="el-icon-discount"></i> ${self.dataObject.storeName}<br><i class="el-icon-present"></i> ${self.dataObject.couponName}</div>`,
                            icons: require('@/assets/images/dialog_ticket.svg'),
                            isCancel: true,
                            isResultEvent: true,
                            eventName: self.dataObject.usedType,
                        });
                        return false
                    }

                    let addCart = function () {
                        return new Promise(function (resolve, reject) {
                            // 有加入購物車的話，會加進sqlite，加過就不用再加了
                            if (!self.isCached) {
                                if (self.isCordova) {
                                    self.$sqlite.insert('insert into ' + self.mealDataTable + ' (meal_id, data_json) values (?, ?);', [self.posFoodId, JSON.stringify(self.posFood)], function (resultSet) {
                                    });
                                } else {
                                    self.$sqlite.insertDB(self.mealDataTable, [{
                                        meal_id: self.posFoodId,
                                        data_json: JSON.stringify(self.posFood)
                                    }], function (resultSet) {
                                    })
                                }
                            }

                            if (self.$route.params.choiceListId !== undefined) {
                                if (self.isCordova) {
                                    self.$sqlite.update('UPDATE ' + self.mealChoiceListTable + ' SET amount=?, choicePrice=?,text_note=?,combination_json=? WHERE id = ?', [self.tempChoiceAmount, self.choicePrice, self.textNote, JSON.stringify(self.tempChoiceList), self.$route.params.choiceListId], function (resultSet) {
                                        resolve();
                                    });
                                } else {
                                    self.$sqlite.queryDB(self.mealChoiceListTable, "", self.$route.params.choiceListId, function (resultSet) {
                                        if (resultSet.length > 0) {
                                            let updateItem = resultSet[0];
                                            updateItem.amount = self.tempChoiceAmount;
                                            updateItem.choicePrice = self.choicePrice;
                                            updateItem.text_note = self.textNote;
                                            updateItem.combination_json = JSON.stringify(self.tempChoiceList);

                                            self.$sqlite.updateDB(self.mealChoiceListTable, [updateItem], function (resultSet) {
                                                resolve();
                                            })
                                        } else {
                                            resolve();
                                        }
                                    })
                                }
                            } else {
                                if (self.isCordova) {
                                    self.$sqlite.query('select id,amount,choicePrice from ' + self.mealChoiceListTable + ' where meal_id = ? and combination_json = ? and text_note = ?', [self.posFoodId, JSON.stringify(self.tempChoiceList), self.textNote], function (resultSet) {
                                        // 如果有相同選項組合，就把數量合併
                                        if (resultSet.rows.length > 0) {
                                            let id = resultSet.rows.item(0).id;
                                            let amount = resultSet.rows.item(0).amount;
                                            let choicePrice = resultSet.rows.item(0).choicePrice;
                                            self.$sqlite.update('UPDATE ' + self.mealChoiceListTable + ' SET amount=?, choicePrice=? WHERE id = ?', [self.tempChoiceAmount + amount, choicePrice + self.choicePrice, id], function (resultSet) {
                                                resolve();
                                            });
                                        } else {
                                            // 沒有的話就新增
                                            self.$sqlite.insert('insert into ' + self.mealChoiceListTable + ' (meal_id,amount,combination_json,text_note,choicePrice) values(?,?,?,?,?)', [self.posFoodId, self.tempChoiceAmount, JSON.stringify(self.tempChoiceList), self.textNote, self.choicePrice], function (resultSet) {
                                                resolve();
                                            })
                                        }
                                    });
                                } else {
                                    self.$sqlite.queryDB(self.mealChoiceListTable, "meal_id", self.posFoodId, function (resultSet) {
                                        let isExist = false;
                                        let updateItem = {}

                                        for (let i = 0; i < resultSet.length; i++) {
                                            let item = resultSet[i];
                                            if (item.text_note === self.textNote && item.combination_json === JSON.stringify(self.tempChoiceList)) {
                                                isExist = true;
                                                updateItem = item
                                                break;
                                            }
                                        }

                                        if (isExist) {
                                            updateItem.amount += self.tempChoiceAmount;
                                            updateItem.choicePrice += self.choicePrice;
                                            self.$sqlite.updateDB(self.mealChoiceListTable, [updateItem], function (resultSet) {
                                                resolve();
                                            })
                                        } else {
                                            self.$sqlite.insertDB(self.mealChoiceListTable, [{
                                                meal_id: self.posFoodId,
                                                amount: self.tempChoiceAmount,
                                                combination_json: JSON.stringify(self.tempChoiceList),
                                                text_note: self.textNote,
                                                choicePrice: self.choicePrice,
                                                stroe_id: self.storeId
                                            }], function (resultSet) {
                                                resolve();
                                            })
                                        }

                                    })
                                }
                            }
                            //設定當前購物車的StoreId（排除沒有設定的時候，已選過的）
                            if (self.storeId !== 0 && self.takeoutId === 0) {
                                self.$store.commit('setCartStoreId', self.storeId);
                            }
                        });
                    }
                    addCart().then(function () {
                        self.analytics.sendEvent(Analytics.EVENTS.ADD_TO_CART, { foodId: self.posFoodId, amount: self.tempChoiceAmount })
                        self.$router.go(-1)
                    });
                }
            },
            clearCart(){
                this.$public.clearCart(this);
                // this.addCart(this.submitBtnStatus);
                this.mealCount = 0
                this.isShowDialog = false;
            },
            numberControllerEvent(obj) {
              let self = this;
              let event = obj.event;

              if (event === "returnNumber") {
                self.tempChoiceAmount = obj.number
              }
            },
            tableOrderAddItem() {
                let self = this;
                self.isLoading = true;
                self.msgDialogStatus = false;

                self.$http.fetchWithAuth`TableOrderAddItem${{
                    orderId: self.dataObject.orderId,
                    tableId: self.dataObject.tableId,
                    storeId: self.dataObject.storeId,
                    isTableOrderAddItemUse: self.isTableOrderAddItemUse,
                    mealApiFormat: self.mealApiFormat(),
                }}
                ${json => {
                    if(json.status) {
                        self.getCurrentTime()
                        self.dialogMsg = '兌換成功<h2 class="mt-2 yellow"><i class="el-icon-time mr-1"></i>'+ self.exchange.time +' </h2><h4 class="green mb-2">'+self.dataObject.storeName+'</h4> <h4><i class="el-icon-present"></i> '+self.dataObject.couponName+'</h4>'
                        self.icons = require('@/assets/images/dialog_complete.gif')
                    } else {
                        self.dialogMsg = json.message
                    }

                    self.msgDialogStatus = json.status
                    self.isShowMsgDialog = true;
                    self.isLoading = false;
                }}`;
            },
            mealApiFormat() {
                let apiFormatData = [];
                // 選項組合
                let combination = JSON.parse(JSON.stringify(this.tempChoiceList));
                // 餐點詳細資料
                let detailList = JSON.parse(JSON.stringify(this.posFood));
                let temp = {
                    isUseTicketAddItem: true,
                    useTicketObject: {
                        objectTypeId: constDefine.TicketType.Coupon.id,
                        objectId: this.dataObject.couponUserId,
                    },
                    id: detailList.posFoodInfo.id,
                    name: detailList.posFoodInfo.onlineOrderName,
                    orderType: detailList.posFoodInfo.orderType,
                    amount: this.tempChoiceAmount,
                    choicePrice: this.choicePrice,
                    textNote: this.textNote,
                    posFoodSubmealList: function () {
                        if (detailList.posFoodInfo.orderType === 2) {
                            let tempSubMealList = [];
                            combination[0].forEach((combinationItem, combinationIndex) => {
                                let mealSet = detailList.dataList[combinationIndex];
                                let subMealInfo = mealSet.posFoodSubmealList[combinationItem];
                                let tempSubMeal = {
                                    mealSetId: mealSet.id,
                                    mealSetName: mealSet.name,
                                    mealSetQuantity: mealSet.quantity,
                                    posFoodId: subMealInfo.posFoodId,
                                    posFoodName: subMealInfo.posFoodName,
                                    increasePrice: subMealInfo.increasePrice,
                                    posFoodSubmealId: subMealInfo.posFoodSubmealId,
                                    // 餐點註記選項
                                    PosGoodsNoteDetailList: function () {
                                        let tempNoteList = [];
                                        combination[1][combinationIndex][combinationItem].forEach((combinationNoteItem, combinationNoteIndex) => {
                                            // 過濾掉沒有選的
                                            if (combinationNoteItem.length > 0) {
                                                let tempNote = subMealInfo.posFoodGoodsNoteList[combinationNoteIndex];
                                                // 過濾掉沒有選的
                                                tempNote.posGoodsNoteDetailList = tempNote.posGoodsNoteDetailList.filter((tempNoteItem, tempNoteIndex) => {
                                                    return combinationNoteItem.indexOf(tempNoteIndex) !== -1;
                                                });
                                                tempNoteList.push(...tempNote.posGoodsNoteDetailList);
                                            }
                                        });
                                        return tempNoteList;
                                    }(),
                                };
                                tempSubMealList.push(tempSubMeal);
                            });
                            return tempSubMealList;
                        }
                    }(),
                    PosGoodsNoteDetailList: function () {
                        if (detailList.posFoodInfo.orderType === 1) {
                            let tempNoteList = [];
                            combination.forEach((combinationItem, combinationIndex) => {
                                // 過濾掉沒有選的
                                if (combinationItem.length > 0) {
                                    let tempNote = detailList.dataList[combinationIndex];
                                    // 過濾掉沒有選的
                                    tempNote.posGoodsNoteDetailList = tempNote.posGoodsNoteDetailList.filter((tempNoteItem, tempNoteIndex) => {
                                        return combinationItem.indexOf(tempNoteIndex) !== -1;
                                    });
                                    tempNoteList.push(...tempNote.posGoodsNoteDetailList);
                                }
                            });
                            return tempNoteList;
                        }
                    }(),
                };
                apiFormatData.push(temp);

                return apiFormatData;
            },
            onDialogResult() {
                if(this.msgDialogStatus) {
                    this.$router.go(-1)
                } else {
                    this.isShowMsgDialog = false;
                }
            },
            getCurrentTime() {
                //兌換成功的時間抓取現在時間
                let hh = new Date().getHours();
                let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
                this.exchange.time = hh+':'+mf;
            }
        },
        watch:{
            // cartStoreId:{
            //     handler:function (newVal,oldVal) {
            //       console.log(newVal,oldVal);
            //     },
            //     deep : true ,
            //     immediate : true,
            // },
            tempChoiceList:{
                handler:function (newVal,oldVal) {
                //   console.log(newVal,oldVal);
                    if (this.orderType===1) {
                        // 驗證單點的選項數量
                        for (const key in this.tempChoiceList) {
                            if (Object.hasOwnProperty.call(this.tempChoiceList, key)) {
                                const element = this.tempChoiceList[key];
                                let note = this.mealCombination[key];
                                if(note.noteSwitch) {
                                    //如果超過限制數量的話
                                    if (note.maxChoice>0&&element.length>note.maxChoice) {
                                        //取消原本的最後一個，換成新的最後一個
                                        this.tempChoiceList[key] = this.tempChoiceList[key].filter((element,index,array)=>{
                                            if (index+1<note.maxChoice||index+1===array.length) {
                                                return true;
                                            }else{
                                                return false;
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }else if (this.orderType===2) {
                        for (const choiceMealKey in this.tempChoiceList[0]) {
                            if (Object.hasOwnProperty.call(this.tempChoiceList[0], choiceMealKey)) {
                                const choiceMeal = this.tempChoiceList[0][choiceMealKey];
                                let combinationElement = this.mealCombination[choiceMealKey];
                                for (const choiceCombinationListKey in this.tempChoiceList[1][choiceMealKey]) {
                                    if (Object.hasOwnProperty.call(this.tempChoiceList[1][choiceMealKey], choiceCombinationListKey)) {
                                        const choiceCombinationList = this.tempChoiceList[1][choiceMealKey][choiceCombinationListKey];
                                        // 如果是以選擇的品項驗證套餐的選項數量
                                        if (choiceMeal===Number(choiceCombinationListKey)) {
                                            // 已選擇品項的選項數量
                                            for (const choiceCombinationKey in this.tempChoiceList[1][choiceMealKey][choiceMeal]) {
                                                if (Object.hasOwnProperty.call(this.tempChoiceList[1][choiceMealKey][choiceMeal], choiceCombinationKey)) {
                                                const choiceCombination = this.tempChoiceList[1][choiceMealKey][choiceMeal][choiceCombinationKey];
                                                let note = this.mealCombination[choiceMealKey]['posFoodSubmealList'][choiceMeal]['posFoodGoodsNoteList'][choiceCombinationKey];
                                                if (note.noteSwitch) {
                                                    if (note.maxChoice > 0 && choiceCombination.length > note.maxChoice) {
                                                        // console.log(this.tempChoiceList[1][choiceMealKey][choiceMeal][choiceCombinationKey]);
                                                        this.tempChoiceList[1][choiceMealKey][choiceMeal][choiceCombinationKey] = this.tempChoiceList[1][choiceMealKey][choiceMeal][choiceCombinationKey].filter((filterElement,filterIndex,filterArray)=>{
                                                            if (filterIndex+1<note.maxChoice||filterIndex+1===filterArray.length) {
                                                                return true;
                                                            }else{
                                                                return false;
                                                            }
                                                        });
                                                    }
                                                }
                                                }
                                            }
                                        }else if(choiceMeal!==Number(choiceCombinationListKey)){
                                            // 如果不是的話重置選項
                                            for (const choiceCombinationKey in this.tempChoiceList[1][choiceMealKey][choiceCombinationListKey]) {
                                                if (Object.hasOwnProperty.call(this.tempChoiceList[1][choiceMealKey][choiceCombinationListKey], choiceCombinationKey)) {
                                                    const choiceCombination = this.tempChoiceList[1][choiceMealKey][choiceCombinationListKey][choiceCombinationKey];
                                                    this.tempChoiceList[1][choiceMealKey][choiceCombinationListKey][choiceCombinationKey] = JSON.parse(JSON.stringify(this.backTempChoiceList[1][choiceMealKey][choiceCombinationListKey][choiceCombinationKey]));

                                                }
                                            }
                                        }

                                    }
                                }
                            }
                        }
                    }
                },
                deep: true ,
                immediate: true,
            },
            '$store.state.publicCommDialogData.isShowDialog': function() {
                if (this.$route.name === 'OrderDetail') {
                    if (!this.$store.state.publicCommDialogData.isShowDialog && this.$store.state.publicCommDialogData.isResultEvent) {
                        if (this.$store.state.publicCommDialogData.result &&
                            this.$store.state.publicCommDialogData.eventName === this.dataObject.usedType) {
                            this.tableOrderAddItem()
                        }

                        this.$store.commit(mutationTypes.setPublicCommDialogData, {
                            isResultEvent: false,
                            eventName: "",
                        });
                    }
                }
            }
        },
        computed: {
            // 算錢
            choicePrice: function () {
                let increasePrice = 0;
                if (this.orderType===1) {
                    for (const tempChoiceKey in this.tempChoiceList) {
                        if (Object.hasOwnProperty.call(this.tempChoiceList, tempChoiceKey)) {
                            const tempChoice = this.tempChoiceList[tempChoiceKey];
                            for (const tempChoiceOptionKey in tempChoice) {
                                if (Object.hasOwnProperty.call(tempChoice, tempChoiceOptionKey)) {
                                    const tempChoiceOption = tempChoice[tempChoiceOptionKey];
                                    increasePrice += this.mealCombination[tempChoiceKey]['posGoodsNoteDetailList'][tempChoiceOption]['increasePrice'];
                                }
                            }

                        }
                    }
                }else if (this.orderType===2){
                    for (const choiceMealKey in this.tempChoiceList[0]) {
                        if (Object.hasOwnProperty.call(this.tempChoiceList[0], choiceMealKey)) {
                            const choiceMeal = this.tempChoiceList[0][choiceMealKey];
                            if (choiceMeal!=='') {
                                increasePrice += this.mealCombination[choiceMealKey]['posFoodSubmealList'][choiceMeal].increasePrice;
                            }
                            for (const tempChoiceKey in this.tempChoiceList[1][choiceMealKey][choiceMeal]) {
                                if (Object.hasOwnProperty.call(this.tempChoiceList[1][choiceMealKey][choiceMeal], tempChoiceKey)) {
                                    const tempChoice = this.tempChoiceList[1][choiceMealKey][choiceMeal][tempChoiceKey];
                                    for (const tempChoiceOptionKey in tempChoice) {
                                        if (Object.hasOwnProperty.call(tempChoice, tempChoiceOptionKey)) {
                                            const tempChoiceOption = tempChoice[tempChoiceOptionKey];
                                            increasePrice += this.mealCombination[choiceMealKey]['posFoodSubmealList'][choiceMeal]['posFoodGoodsNoteList'][tempChoiceKey]['posGoodsNoteDetailList'][tempChoiceOption].increasePrice
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return (this.price+increasePrice)*this.tempChoiceAmount;
            },
            // 驗證加入購物車按鈕相關事件
            submitBtnStatus:function () {
                let disabled = false;
                let self = this;
                let disabledDo = [];
                if (this.orderType===1) {
                    // 驗證單點的選項數量
                    for (const key in this.tempChoiceList) {
                        if (Object.hasOwnProperty.call(this.tempChoiceList, key)) {
                            const element = this.tempChoiceList[key];
                            let note = this.mealCombination[key];
                            if(note.noteSwitch) {
                              if (note.maxChoice>0&&element.length>note.maxChoice) {
                                  disabledDo.push(function () {
                                      self.$public.showNotify(note.posGoodsNoteName+'最多選擇'+note.maxChoice);
                                      document.querySelector('[noteId="'+note.posGoodsNoteId+'"]').scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
                                  });
                                  disabled = true;
                                  break;
                              }else if(note.minChoice>0&&element.length<note.minChoice){
                                  disabledDo.push(function () {
                                      self.$public.showNotify(note.posGoodsNoteName+'至少選擇'+note.minChoice);
                                      document.querySelector('[noteId="'+note.posGoodsNoteId+'"]').scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
                                  });
                                  disabled = true;
                                  break;
                              }
                            }
                        }
                    }
                }else if (this.orderType===2) {
                    // 驗證套餐的選項數量
                    for (const choiceMealKey in this.tempChoiceList[0]) {
                        if (disabled) {
                            break;
                        }
                        if (Object.hasOwnProperty.call(this.tempChoiceList[0], choiceMealKey)) {
                            const element = this.tempChoiceList[0][choiceMealKey];
                            let combinationElement = this.mealCombination[choiceMealKey];
                            // 套餐的每個主餐及配餐需選一個
                            if (element==='') {
                                disabledDo.push(function () {
                                    self.$public.showNotify(combinationElement.name+'至少選擇一項');
                                    self.$store.commit(mutationTypes.SHOW_TOAST, combinationElement.name+'至少選擇一項');
                                    document.querySelector('[combinationElementId="'+combinationElement.id+'"]').scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
                                });
                                disabled = true;
                                break;
                            }
                            // 已選擇品項的選項數量
                            for (const tempChoiceKey in this.tempChoiceList[1][choiceMealKey][element]) {
                                if (Object.hasOwnProperty.call(this.tempChoiceList[1][choiceMealKey][element], tempChoiceKey)) {
                                  const tempChoice = this.tempChoiceList[1][choiceMealKey][element][tempChoiceKey];
                                  let note = this.mealCombination[choiceMealKey]['posFoodSubmealList'][element]['posFoodGoodsNoteList'][tempChoiceKey];
                                  if (note.noteSwitch) {
                                    if (note.maxChoice > 0 && tempChoice.length > note.maxChoice) {
                                      disabledDo.push(function () {
                                        self.$public.showNotify(note.posGoodNoteName+'最多選擇'+note.maxChoice);
                                        self.$store.commit(mutationTypes.SHOW_TOAST, note.posGoodNoteName + '最多選擇' + note.maxChoice);
                                        document.querySelector('[combinationElementId="' + combinationElement.id + '"]' + ' ' + '[noteId="' + note.posGoodsNoteId + '"]').scrollIntoView({
                                          behavior: "smooth",
                                          block: "center",
                                          inline: "nearest"
                                        });
                                      });
                                      disabled = true;
                                      break;
                                    } else if (note.minChoice > 0 && tempChoice.length < note.minChoice) {
                                      disabledDo.push(function () {
                                        self.$public.showNotify(note.posGoodNoteName+'至少選擇'+note.minChoice);
                                        self.$store.commit(mutationTypes.SHOW_TOAST, note.posGoodNoteName + '至少選擇' + note.minChoice);
                                        document.querySelector('[noteId="' + note.posGoodsNoteId + choiceMealKey+'"]').scrollIntoView({
                                          behavior: "smooth",
                                          block: "center",
                                          inline: "nearest"
                                        });
                                      });
                                      disabled = true;
                                      break;
                                    }
                                  }
                                }
                            }
                        }
                    }
                }
                return {
                    disabled: disabled,
                    disabledDo: disabledDo,
                }
            }
        },
    }
</script>

<style lang="less" scoped src="../../less/order.less"/>